import React from 'react';
import Text from '@service-victoria/component-library/components/Text';

export const TravelDetailsContent: React.FC<Record<string, never>> = () => (
  <>
    <Text.Heading.H1 fontWeight={600}>Travel details</Text.Heading.H1>
  </>
);

export default TravelDetailsContent;
